// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1054":"6719780ebacdfad1","2888":"950f180d82bc5c42","5405":"6719780ebacdfad1"}[chunkId] + ".css";
};